var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheatre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.257,
    height: 122.674,
    viewBox: "0 0 120.257 122.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-theatre-4871207",
    transform: "translate(-107.329 -31.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    "data-name": "Caminho 595",
    d: "M397.622,260.743a2.29,2.29,0,0,1-1.678-.734c-5.245-5.689-11-8.079-17.6-7.3a2.281,2.281,0,1,1-.537-4.53c8.04-.954,15.271,1.987,21.488,8.733a2.279,2.279,0,0,1-1.674,3.824Z",
    transform: "translate(-202.301 -163.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    "data-name": "Caminho 596",
    d: "M313.519,114.043a2.281,2.281,0,0,1-.589-4.484c2.169-.58,4.338-1.234,6.451-1.949,8.634-2.912,23.461-9.294,25.788-19.308l8.8-37.91c-21.166.861-40.756-3.674-58.332-13.5l-8.792,37.863a15.2,15.2,0,0,0-.173,5.695,2.278,2.278,0,0,1-4.506.673,19.73,19.73,0,0,1,.244-7.4l9.484-40.86a2.281,2.281,0,0,1,3.389-1.44c18.286,10.917,38.96,15.714,61.45,14.259a2.28,2.28,0,0,1,2.366,2.792l-9.485,40.86c-2.683,11.561-17.127,18.672-28.772,22.6-2.206.743-4.469,1.426-6.731,2.034a2.368,2.368,0,0,1-.589.079Z",
    transform: "translate(-131.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_597",
    "data-name": "Caminho 597",
    d: "M468.1,161.818a10.193,10.193,0,0,1-4.581-1.023c-3.038-1.51-5.2-4.624-6.423-9.252a2.28,2.28,0,0,1,4.408-1.164c.87,3.3,2.23,5.432,4.044,6.33s4.366.692,7.558-.622a2.281,2.281,0,1,1,1.74,4.217,17.864,17.864,0,0,1-6.741,1.514Z",
    transform: "translate(-263.512 -88.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_598",
    "data-name": "Caminho 598",
    d: "M354.17,147.893c-3.253,0-6.507-1.683-9.68-5a2.278,2.278,0,0,1,3.3-3.146c2.361,2.468,4.576,3.679,6.6,3.59s4.156-1.5,6.315-4.2a2.278,2.278,0,1,1,3.557,2.848c-3.015,3.768-6.268,5.755-9.671,5.9-.136,0-.276.01-.412.01Z",
    transform: "translate(-178.239 -80.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    "data-name": "Caminho 599",
    d: "M236.8,406.966a29.3,29.3,0,0,1-10.611-2.151,2.279,2.279,0,1,1,1.65-4.249c9.443,3.66,17.324,1.833,24.092-5.586a2.28,2.28,0,1,1,3.365,3.076c-5.418,5.938-11.612,8.915-18.492,8.915Z",
    transform: "translate(-88.471 -273.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_600",
    "data-name": "Caminho 600",
    d: "M157.766,271.749a2.348,2.348,0,0,1-.44-.042c-1.472-.29-36.155-7.336-40.448-25.82l-9.489-40.86a2.277,2.277,0,0,1,2.365-2.791c22.485,1.454,43.159-3.342,61.45-14.259a2.28,2.28,0,0,1,3.389,1.44l9.484,40.86c4.469,19.238-23.765,40.148-24.972,41.027a2.261,2.261,0,0,1-1.346.44Zm-45.249-64.8,8.8,37.91c3.272,14.086,30.361,20.906,35.906,22.164,4.454-3.469,25.834-21.005,22.418-35.707l-8.793-37.863c-17.58,9.827-37.175,14.357-58.337,13.5Z",
    transform: "translate(0 -117.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_601",
    "data-name": "Caminho 601",
    d: "M169.071,337.91a2.279,2.279,0,0,1-2.005-3.357c2.285-4.25,5.127-6.793,8.446-7.555s6.951.28,10.831,3.09a2.28,2.28,0,0,1-2.674,3.694c-2.767-2.006-5.17-2.792-7.137-2.338s-3.815,2.23-5.451,5.269a2.277,2.277,0,0,1-2.01,1.2Z",
    transform: "translate(-44.811 -222.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_602",
    "data-name": "Caminho 602",
    d: "M287.521,310.395a2.279,2.279,0,0,1-2.005-3.357c2.285-4.25,5.128-6.792,8.446-7.555s6.951.28,10.831,3.09a2.28,2.28,0,0,1-2.674,3.694c-2.767-2-5.17-2.792-7.137-2.338s-3.815,2.23-5.451,5.269a2.276,2.276,0,0,1-2.01,1.2Z",
    transform: "translate(-134.07 -202.054)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatre);
export default __webpack_public_path__ + "static/media/theatre.90526ccab5018a4d90391aa6f274a58d.svg";
export { ForwardRef as ReactComponent };